var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useCallback, useRef } from 'react';
import { useToggle } from '../../../../infra/small-tools/use-toggle';
import { ReportingAiBotModal } from './reporting-ai-bot-modal';
import { useModalMode } from './use-modal-mode';
import { useModalAnimationState } from './use-modal-animation-state';
import { useChat } from '../hooks/use-chat';
import { queryClient } from '../../../../../queryClient';
import { queryKeys } from '../network/query-keys';
import { endpoints } from '../network';
import { RudderstackTracker } from '../../../../infra/observability/rudderstack/rudderstack';
import { REPORTING_BOT_QUERY_INTERRUPTED, REPORTING_BOT_SUGGESTION_CLICKED, } from '../../../../infra/observability/rudderstack/events';
export var ReportingAiBotModalContainer = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, chatHistory = _a.chatHistory, isHistoryLoading = _a.isHistoryLoading, autoOpenResult = _a.autoOpenResult;
    var historySidebarToggle = useToggle(false);
    var _b = useModalMode(), modalMode = _b.modalMode, expandModal = _b.expandModal, compactModal = _b.compactModal;
    var chat = useChat();
    var hasAttemptedAutoOpen = useRef(false);
    var handleClose = function () {
        hasAttemptedAutoOpen.current = false;
        onClose();
        compactModal();
        historySidebarToggle.setOff();
        chat.startNewChat();
    };
    var _c = useModalAnimationState({
        isOpen: isOpen,
        onClose: handleClose,
    }), animationState = _c.animationState, handleCloseWithAnimation = _c.handleCloseWithAnimation, isOpenOrClosing = _c.isOpenOrClosing;
    var handleBackdropKeyDown = function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClose();
        }
    };
    var showConversationView = useCallback(function () {
        expandModal();
        historySidebarToggle.setOff();
    }, [expandModal, historySidebarToggle]);
    var handleNewConversation = function () {
        showConversationView();
        chat.startNewChat();
    };
    var handleSendMessage = function (message, startNewChat) {
        if (startNewChat === void 0) { startNewChat = false; }
        showConversationView();
        if (startNewChat) {
            chat.startNewChat();
        }
        chat.sendMessage(message);
    };
    var handleSuggestionClick = function (suggestion) {
        handleSendMessage(suggestion, true);
        RudderstackTracker.getInstance().track(REPORTING_BOT_SUGGESTION_CLICKED);
    };
    var handleOpenExistingChat = useCallback(function (chatId) { return __awaiter(void 0, void 0, void 0, function () {
        var chatLog;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, queryClient.fetchQuery({
                        queryKey: queryKeys.chatLog(chatId),
                        queryFn: function () { return endpoints.chatLogQuery.request({ chatId: chatId }); },
                    })];
                case 1:
                    chatLog = _a.sent();
                    showConversationView();
                    if (chat.isResponding) {
                        RudderstackTracker.getInstance().track(REPORTING_BOT_QUERY_INTERRUPTED);
                    }
                    chat.loadChatLog(chatLog);
                    return [2 /*return*/];
            }
        });
    }); }, [showConversationView, chat]);
    useEffect(function () {
        if (!isOpen || hasAttemptedAutoOpen.current) {
            return;
        }
        hasAttemptedAutoOpen.current = true;
        if ((autoOpenResult === null || autoOpenResult === void 0 ? void 0 : autoOpenResult.shouldAutoOpen) && autoOpenResult.chatId) {
            expandModal();
            handleOpenExistingChat(autoOpenResult.chatId);
        }
    }, [isOpen, autoOpenResult, expandModal, handleOpenExistingChat]);
    return (_jsx(ReportingAiBotModal, { isOpen: isOpenOrClosing, onClose: handleCloseWithAnimation, onBackdropKeyDown: handleBackdropKeyDown, modalMode: modalMode, animationState: animationState, historySidebarToggle: historySidebarToggle, onNewConversation: handleNewConversation, onOpenExistingChat: handleOpenExistingChat, onSuggestionClick: handleSuggestionClick, onMessageSubmit: handleSendMessage, chat: chat, chatHistory: chatHistory || [], isHistoryLoading: isHistoryLoading }));
};
